import React from 'react';
//import css from './css.module.less';
import BlockTitle from '@/src/components/Modules-revamp/BlockTitle';
import {
  Item as ItemWrapper,
  SectionContainer as Section,
} from 'src/components/Layouts';
import Wrapper from 'src/components/Modules-revamp/BlockWrapper';
import {
  FlashSaleBarStyle,
  backgroundColor,
  comingSoonPrice,
  comingSoonStatus,
  flashSaleBarStyle,
  saleNowPrice,
  saleNowStatus,
  salesNowCountDownTimer,
  textColor,
} from 'src/pages/SalesChannelContentEditor/SalesChannelEditorAppearanc-revamp/constant';

import { Field } from 'src/components/RcForm';

import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
//import { get } from 'lodash';

import ColorPicker from 'src/components/Modules-revamp/ColorPicker';

const sectionProps = {
  size: 'small',
  style: { paddingTop: 0 },
};

const FSBS = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { breakpoint, disabled } = props;

  return (
    <Wrapper id={FlashSaleBarStyle} breakpoint={breakpoint}>
      <BlockTitle
        id={FlashSaleBarStyle}
        title={getI18n('general.hOCTitle.flashSaleBarStyle')}
        breakpoint={breakpoint}
        onReset={
          () => {
            return;
          } // handleOnSectionReset(item?.fields, breakpoint)
        }
        onCopy={
          () => {
            return;
          } // handleOnSectionCopy(item?.fields, breakpoint)}
        }
        headerErrorDependencies={[]}
        validator={() => {
          return;
        }}
      />
      <Section {...sectionProps}>
        <ItemWrapper
          title={getI18n('general.status')}
          bottomTitle={getI18n(
            'salesChannelContent.index.comingSoon',
          )}></ItemWrapper>
        <ItemWrapper
          title={getI18n(
            'salesChannelContent.index.statusSectionBackgroundColour',
          )}>
          <Field name={[flashSaleBarStyle, comingSoonStatus, backgroundColor]}>
            <ColorPicker multi disabled={disabled} />
          </Field>
        </ItemWrapper>
        <ItemWrapper
          title={getI18n('salesChannelContent.index.statusTextColour')}>
          <Field name={[flashSaleBarStyle, comingSoonStatus, textColor]}>
            <ColorPicker multi disabled={disabled} />
          </Field>
        </ItemWrapper>
        <ItemWrapper
          title={getI18n(
            'salesChannelContent.index.priceSectionBackgroundColour',
          )}>
          <Field name={[flashSaleBarStyle, comingSoonPrice, backgroundColor]}>
            <ColorPicker multi disabled={disabled} />
          </Field>
        </ItemWrapper>
        <ItemWrapper
          title={getI18n('salesChannelContent.index.priceSectionTextColour')}>
          <Field name={[flashSaleBarStyle, comingSoonPrice, textColor]}>
            <ColorPicker multi disabled={disabled} />
          </Field>
        </ItemWrapper>
      </Section>
      <Section {...sectionProps}>
        <ItemWrapper
          title={getI18n('general.status')}
          bottomTitle={getI18n(
            'salesChannelContent.index.saleNow',
          )}></ItemWrapper>
        <ItemWrapper
          title={getI18n(
            'salesChannelContent.index.statusSectionBackgroundColour',
          )}>
          <Field name={[flashSaleBarStyle, saleNowStatus, backgroundColor]}>
            <ColorPicker multi disabled={disabled} />
          </Field>
        </ItemWrapper>
        <ItemWrapper
          title={getI18n('salesChannelContent.index.statusTextColour')}>
          <Field name={[flashSaleBarStyle, saleNowStatus, textColor]}>
            <ColorPicker multi disabled={disabled} />
          </Field>
        </ItemWrapper>
        <ItemWrapper
          title={getI18n(
            'salesChannelContent.index.countDownTimerBackgroundColour',
          )}>
          <Field
            name={[flashSaleBarStyle, salesNowCountDownTimer, backgroundColor]}>
            <ColorPicker multi disabled={disabled} />
          </Field>
        </ItemWrapper>
        <ItemWrapper
          title={getI18n('salesChannelContent.index.countDownTimerTextColour')}>
          <Field name={[flashSaleBarStyle, salesNowCountDownTimer, textColor]}>
            <ColorPicker multi disabled={disabled} />
          </Field>
        </ItemWrapper>
        <ItemWrapper
          title={getI18n(
            'salesChannelContent.index.priceSectionBackgroundColour',
          )}>
          <Field name={[flashSaleBarStyle, saleNowPrice, backgroundColor]}>
            <ColorPicker multi disabled={disabled} />
          </Field>
        </ItemWrapper>
        <ItemWrapper
          title={getI18n('salesChannelContent.index.priceSectionTextColour')}>
          <Field name={[flashSaleBarStyle, saleNowPrice, textColor]}>
            <ColorPicker multi disabled={disabled} />
          </Field>
        </ItemWrapper>
      </Section>
    </Wrapper>
  );
};
export default FSBS;
